module.exports = __webpack_public_path__ + "img/message-agree.f4678c6d.png";